import React, { useState } from "react";
import { tuitionConfigs } from "../../data/tuitionConfigs";

export default function TuitionCalculator() {
  const [campus, setCampus] = useState("gapan");
  const [levelIdx, setLevelIdx] = useState(0);
  const [modeIdx, setModeIdx] = useState(0);

  const levels = tuitionConfigs[campus]?.levels || [];
  const paymentModes = levels[levelIdx]?.paymentModes || [];
  const selectedMode = paymentModes[modeIdx] || {};

  return (
    <div className="container mt-4">
      <h2>Tuition Fee Calculator</h2>
      <div className="row mb-3">
        <div className="col-md-4">
          <label className="form-label">Campus</label>
          <select className="form-select" value={campus} onChange={e => {
            setCampus(e.target.value);
            setLevelIdx(0);
            setModeIdx(0);
          }}>
            <option value="gapan">Gapan</option>
            <option value="bulacan">Bulacan</option>
          </select>
        </div>
        <div className="col-md-4">
          <label className="form-label">Level</label>
          <select className="form-select" value={levelIdx} onChange={e => {
            setLevelIdx(Number(e.target.value));
            setModeIdx(0);
          }}>
            {levels.map((lvl, idx) => (
              <option key={lvl.name} value={idx}>{lvl.name}</option>
            ))}
          </select>
        </div>
        <div className="col-md-4">
          <label className="form-label">Payment Mode</label>
          <select className="form-select" value={modeIdx} onChange={e => setModeIdx(Number(e.target.value))}>
            {paymentModes.map((pm, idx) => (
              <option key={pm.mode} value={idx}>{pm.mode}</option>
            ))}
          </select>
        </div>
      </div>

      {selectedMode && (
        <div className="card mt-4">
          <div className="card-body">
            <h5 className="card-title">{levels[levelIdx]?.name} - {selectedMode.mode}</h5>
            <p>
              <strong>Tuition Fee:</strong> ₱{selectedMode.tuitionFee?.toLocaleString()}<br />
              <strong>Miscellaneous Fee:</strong> ₱{selectedMode.miscFee?.toLocaleString()}<br />
              <strong>Discount:</strong> {selectedMode.discount * 100}%<br />
              <strong>Total Due:</strong> ₱{selectedMode.totalDue?.toLocaleString()}
            </p>
            <h6>Payment Schedule:</h6>
            <ul>
              {selectedMode.schedule?.map((sched, idx) => (
                <li key={idx}>
                  <strong>{sched.label}:</strong>
                  {sched.misc && <> Misc: ₱{sched.misc.toLocaleString()} </>}
                  {sched.tuition && <> Tuition: ₱{sched.tuition.toLocaleString()} </>}
                  {sched.total && <> Total: ₱{sched.total.toLocaleString()} </>}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}